import BasicRepository, {AllArgs, ListArgs} from "./basicRepository";
import Client from "../client";
import {LibraryVariableSetResource, VariableSetContentType} from "../resources/libraryVariableSetResource";

interface LibraryVariableAllArgs extends AllArgs {
    contentType?: VariableSetContentType;
}

interface LibraryVariableListArgs extends ListArgs {
    contentType?: VariableSetContentType;
}

class LibraryVariableRepository extends BasicRepository<LibraryVariableSetResource, LibraryVariableSetResource, LibraryVariableListArgs, LibraryVariableAllArgs> {
    constructor(client: Client) {
        super("LibraryVariables", client);
    }
}

export default LibraryVariableRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/libraryVariableRepository.ts